import React from "react";
//#region types
import { ACTION_SEPARATOR, ButtonGroupProps } from "models/propTypes/menuPropTypes";
//#endregion
//#region components
import { Divider, Grid } from "@mui/material";
//#endregion
import cssExports from "theme/styles/main.module.scss";
import clsx from "clsx";

const ButtonGroup: React.FC<ButtonGroupProps> = (props) => {
  const { buttons, className } = props;
  return (
    <Grid item className={clsx(cssExports.buttonGroup, className)}>
      <Grid container spacing={1} direction="row" alignItems="center" className={cssExports.buttonGroupWrapper}>
        {buttons.map((button, index) =>
          typeof button === typeof ACTION_SEPARATOR ? (
            <Divider key={index} orientation="vertical" flexItem className={cssExports.divider} />
          ) : (
            <Grid key={index} item>
              {button}
            </Grid>
          )
        )}
      </Grid>
    </Grid>
  );
};

export default ButtonGroup;
